// component
import Iconify from '../../components/Iconify';
import {useLanguage} from "../../context/LanguageContext";

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default function NavConfig() {
  const { t } = useLanguage();

  const homeTitle = t('home.title'); // Dashboard
  const commandsTitle = t('commands.title'); // Commands
  const settings  = t('settings') // Settings
  const downloads = t('downloads'); // Downloads
  const help = t('help'); // Help

  return [
    {
      title: homeTitle,
      path: '/dashboard/app',
      icon: getIcon('solar:microphone-3-bold-duotone'),
    },
    {
      title: commandsTitle,
      path: '/dashboard/commands',
      icon: getIcon('solar:command-bold-duotone'),
    },
    {
      title: settings,
      path: '/dashboard/settings',
      icon: getIcon('solar:tuning-2-bold-duotone'),
    },
    {
      title: downloads,
      path: '/dashboard/downloads',
      icon: getIcon('solar:download-square-bold-duotone'),
    },
    {
      title: help,
      path: '/dashboard/help',
      icon: getIcon('solar:question-circle-bold-duotone'),
    },
  ];
}
